import { downloadIcon, viewIcon, } from "assets/icons";
import Placeholder from "components/placeholder/Placeholder";
import React, { useEffect, useState } from "react";
import { FaRegFileAlt, FaRegFileExcel, FaRegFilePdf } from "react-icons/fa";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link, useParams } from "react-router-dom";
import { fileListApi } from "services/mySites";
import { FileShimmer } from "shimmer/documentRepository";
import { downloadFile, formatFileSize, openFileInNewTab, showExtension } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

const DocumentFiles = () => {
  const { folderName, siteId, fileName, folderId } = useParams()
  const [fileList, setFileList] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Map of file extensions to icons
  const docTypes = {
    pdf: <FaRegFilePdf />,
    doc: <FaRegFileExcel />,
    docx: <FaRegFileExcel />,
    txt: <FaRegFileAlt />,
  };
  // Function to get the icon based on the file extension
  const getFileIcon = (fileName) => {
    const extension = fileName?.split(".").pop().toLowerCase();
    return docTypes[extension] || <FaRegFileAlt />; // Default icon for unknown types
  };

  //--------folder-listing--------------
  const getFileList = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true)
      const params = ({
        siteId: siteId,
        folderId: folderId,
        limit: 9,
        page,
      })
      const res = await fileListApi(params)
      if (res?.status === 200) {
        const data = res?.data?.data
        // setFileList(data || [])
        if (isRefresh) {
          setFileList(data || []);
        } else {
          setFileList((prev) => [...prev, ...(data || [])]);
        }
        setHasMore(data.length === 9);
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log('error', e?.message)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    setPage(1);
    setHasMore(true);
    getFileList(1, true);
  }, [siteId]);

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    getFileList(nextPage);
  };
  return (
    <>
      <div className="documentFolders">
        <div className="breadcrumb_wrap">
          <ul>
            <li>
              <Link to={-2}>Document Repository </Link>
            </li>
            <li>
              <Link to={-1}>{folderName}</Link>{" "}
            </li>
            <li>{fileName}</li>
          </ul>
        </div>
        <div className="folder_list file_list">

          {!loading && fileList.length === 0 ?
            <Placeholder title={"No data found"} />
            :
            <InfiniteScroll
              dataLength={fileList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<FileShimmer count={1} />}
            >
              <ul>
                {fileList.length > 0 && fileList.map((data, ind) => (
                  <li key={ind}>
                    <div className="image_wrap">
                      {getFileIcon(data.name)}
                      <div className="button_wrap">

                        <button
                          className="me-1"
                          onClick={() => openFileInNewTab(data?.fileUrl)}
                          type="button"
                        >
                          <img src={viewIcon} alt="" />
                        </button>

                        <button
                          onClick={() => downloadFile(data?.fileUrl, data?.name)}
                          type="button"
                        >
                          <img src={downloadIcon} alt="" />
                        </button>

                      </div>
                    </div>
                    <b>{data.name}</b>
                    <span>{formatFileSize(data.size)} {showExtension(data.name)}</span>
                  </li>
                ))}
              </ul>
            </InfiniteScroll>
          }
        </div>
      </div>
    </>
  );
};
export default DocumentFiles;
